module.exports = __webpack_public_path__ + "static/icons/icon-holidays-50fa77f88ab860927ba69b23a76dfaa7.svg";